"use client";

import { twMerge } from "tailwind-merge";

import { NormalText } from "@/components/text/NormalText";
import { SmallTitle } from "@/components/text/SmallTitle";
import { UserNoDates } from "@/types/types";
import { getSecondsLeft } from "@/utils/subscriptionLevels/time/getSecondsLeft";
import { getFormattedTimeLeft } from "@/utils/time/getFormattedTimeLeft";

export function TimeLeftCard({
  user,
  className,
}: {
  user: UserNoDates;
  className?: string;
}) {
  const secondsLeft = getSecondsLeft(user);

  let formattedTimeLeft: string;
  if (secondsLeft === null) {
    formattedTimeLeft = "Unlimited";
  } else {
    formattedTimeLeft = getFormattedTimeLeft(secondsLeft);
  }

  return (
    <div
      className={twMerge("rounded-2xl bg-primaryLight px-4 py-3", className)}
    >
      <NormalText
        elementType="span"
        className="block text-xs font-medium text-gray-600"
      >
        Time left
      </NormalText>
      <SmallTitle
        elementType="span"
        className="mt-0.5 block break-words text-gray-900"
      >
        {formattedTimeLeft}
      </SmallTitle>
    </div>
  );
}
